import { render, staticRenderFns } from "./WindowsButton.vue?vue&type=template&id=33cd5db9&scoped=true&"
import script from "./WindowsButton.vue?vue&type=script&lang=js&"
export * from "./WindowsButton.vue?vue&type=script&lang=js&"
import style0 from "./WindowsButton.vue?vue&type=style&index=0&id=33cd5db9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cd5db9",
  null
  
)

export default component.exports